export default "__VITE_ASSET__DtJlSE$H__"